import * as React from "react";
import styles from "./index.module.css";
import { RadioGroupProps } from "../types";
import Spacer from "../Spacer/index";

function RadioGroup(props: RadioGroupProps) {
  function id() {
    return props.label.replace(/ /g, "");
  }

  function orientationValue() {
    return props.orientation || "horizontal";
  }

  return (
    <div
      role="radiogroup"
      className={styles.container}
      aria-labelledby={id()}
      aria-orientation={orientationValue()}
    >
      <div className={styles.label} id={id()}>
        {props.label}
      </div>
      {orientationValue() === "horizontal" ? <Spacer x={1} /> : null}
      {orientationValue() === "horizontal" ? <Spacer y={1} /> : null}
      <div className={styles.inputs}>{props.children}</div>
    </div>
  );
}

export default RadioGroup;
